import { useState, useEffect } from 'react';

import { getContext, isContextAvailable } from '@/miniappContext';

export interface AuthUser {
  isAuthorized: boolean;
  isLoading: boolean;
}

const MAX_LOADER_MS = 2000;

export function useAuthUser(): AuthUser {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isContextAvailable()) {
      setIsLoading(false);
      return;
    }

    const timeoutId = setTimeout(() => setIsLoading(false), MAX_LOADER_MS);

    const ctx = getContext();
    const initial = !!ctx.general.auth.getState().isAuthorized;
    if (initial) {
      setIsAuthorized(true);
      setIsLoading(false);
    }

    const unsubscribe = ctx.general.auth.subscribe(authInfo => {
      setIsAuthorized(!!authInfo.isAuthorized);
      setIsLoading(false);
    });

    return () => {
      clearTimeout(timeoutId);
      unsubscribe();
    };
  }, []);

  return { isAuthorized, isLoading };
}
